const questionTypeAllowList = [
  'Local inference',
  'Global inference', // Older tests use "Global inference", newer tests use "Complex inference".
  'Complex inference',
  'Retrieval',
  'Interpret & integrate',
  'Critique & evaluate'
];

export const getQuestionTypeClassName = (questionType: string | undefined): string => {
  if (
    !questionType ||
    !questionTypeAllowList.map((qt) => qt.toLowerCase()).includes(questionType.toLowerCase())
  ) {
    return ''; // Only populate the className if the question type exists.
  }
  // Should be a lowercase, hyphened, string without special characters:
  return questionType.replaceAll(' ', '-').replaceAll('&', 'and').toLowerCase();
};
